"use client";

import React from "react";
import Link from "next/link";
import Image from "next/image";
import { NavbarLink } from "../navbarData";

const DrawerLinkArrow = "/assets/icons/drawer-link-arrow.svg";

type Props = {
    link: NavbarLink;
    onClick?: () => void;
};

export default function DrawerItem({ link, onClick }: Props) {
    const { href, label, variant, showArrow } = link;
    const isButton = Boolean(onClick);

    const commonClasses = "drawer-link flex items-center justify-between p-[10px_16px] rounded-full font-bold md:text-[15px] text-[12px] no-underline";

    const buttonExtraClasses = isButton ? "cursor-pointer text-left w-full" : "";


    let borderClass = "";
    if (isButton) {
        borderClass = `border ${variant === "secondary" ? "border-[#d3d4da]" : "border-[#EFEFEF]"}`;
    } else {
        borderClass = variant === "secondary" ? "border-[#d3d4da]" : "border-[#EFEFEF] border";
    }

    let bgTextClass = "bg-[#ffffff] text-[#1b365e]";
    if (variant === "secondary") bgTextClass = "bg-[#efefef] text-[#1B515E]";
    else if (variant === "highlight_two") bgTextClass = "bg-[#EFEFEF] text-[#1B365E]";
    else if (variant === "contact") bgTextClass = "bg-[#FFE4B4] text-[#1b365e]";

    const finalClassName = `${commonClasses} ${buttonExtraClasses} ${borderClass} ${bgTextClass}`;

    const content = (
        <>
            <span>{label}</span>
            {showArrow && (
                <span className="drawer-link__arrow flex items-center justify-center w-4 h-[17.34px]" aria-hidden="true">
                    <Image
                        className="w-[10.46px] h-[17.34px] object-contain block pointer-events-none"
                        src={DrawerLinkArrow}
                        width={24}
                        height={24}
                        alt="Ouvrir"
                        title="Ouvrir"
                        draggable="false"
                    />
                </span>
            )}
        </>
    );

    if (isButton) {
        return (
            <button type="button" onClick={onClick} className={finalClassName}>
                {content}
            </button>
        );
    }

    return (
        <Link href={href} title={label} className={finalClassName}>
            {content}
        </Link>
    );
}
